import { schema } from "normalizr";
import { CarrierServicesList as CarrierServiceListRecord } from "records/shipping-accounts";

export const CarrierServiceList = new schema.Entity(
    "carrierServiceList",
    {},
    {
        idAttribute: (services) => {
            return services[0].carrier_id;
        },
        processStrategy: (services) => {
            return {
                services,
                carrierId: services[0].carrier_id,
            };
        },
    }
);

(CarrierServiceList as any).record = CarrierServiceListRecord;
